import { createSvgIcon } from '../../createSvgIcon';

export const NumberIcon = createSvgIcon(
  <path
    d="M0 0.75H1.29104V9.78727M1.29104 9.78727H0M1.29104 9.78727H2.58208M3.87312 0.75H9.03727V5.26864H4.51864V9.78727H9.68279M10.9738 0.75H15.4925V5.26864M15.4925 5.26864H11.6193M15.4925 5.26864V9.78727H10.9738"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.5}
  />,
  { displayName: 'NumberIcon', viewBox: '0 0 17 11' }
);
